export const emailRegex = /^(.+)@(\S+)\.(\S+)$/;
export const ibanRegex = /^[A-Z]{2}[0-9]{2}[0-9A-Z \t]{1,30}$/;

export const urlRegex =
  /^[a-z]+:\/\/[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]$/;
